import { render, staticRenderFns } from "./GroupDashboardOffices.vue?vue&type=template&id=645cc8ec&"
import script from "./GroupDashboardOffices.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardOffices.vue?vue&type=script&lang=js&"
import style0 from "./GroupDashboardOffices.vue?vue&type=style&index=0&id=645cc8ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports